import { render, staticRenderFns } from "./DragSourceView.vue?vue&type=template&id=15aa2064&scoped=true&"
import script from "./DragSourceView.vue?vue&type=script&lang=js&"
export * from "./DragSourceView.vue?vue&type=script&lang=js&"
import style0 from "./DragSourceView.vue?vue&type=style&index=0&id=15aa2064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa2064",
  null
  
)

export default component.exports